import { Suspense, type PropsWithChildren } from 'react'

import { EmpreendimentoMidiasPageSkeleton } from '@/features/empreendimentos/shared/components/empreendimento-midias.skeleton'
import { PageLayoutSkeleton } from '@/layouts/page'

export const EmpreendimentoMidiasPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <EmpreendimentoMidiasPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
